import {
  Box,
  Container,
  Flex,
  HStack,
  Text,
  Divider,
  // eslint-disable-next-line no-restricted-imports
  Icon as ChakraIcon,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { YapamarLogo } from 'src/components/atoms/YapamarLogo';
import { FOOTER_LINKS } from '../../../utils/constants';
import { Boxes, CreditCard, BookOpen, Newspaper, Phone } from 'lucide-react';
import { LucideIcon } from 'lucide-react';

const companyIcons: Record<string, LucideIcon> = {
  Product: Boxes,
  Pricing: CreditCard,
  Resources: BookOpen,
  Blog: Newspaper,
  'Contact Sales': Phone,
};

const companyLinks =
  FOOTER_LINKS.find((s) => s.heading === 'Company')?.links ?? [];
const legalLinks = FOOTER_LINKS.find((s) => s.heading === 'Legal')?.links ?? [];

const MarketingPageFooter: React.FC = () => {
  return (
    <Box
      bg="white"
      color="gray.700"
      pt={{ base: 8, md: 10 }}
      pb={{ base: 20, md: 20 }}
      px={{ base: 6, md: 12 }}>
      <Container maxW="container.xl" px={0}>
        {/* Top row: Logo + Company links */}
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          gap={{ base: 6, md: 4 }}>
          <Box>
            <YapamarLogo theme="dark" clickable={false} />
            <Text
              mt={4}
              fontSize="sm"
              color="gray.500"
              fontFamily="marketingPage">
              Smarter marketing measurement, built for action.
            </Text>
          </Box>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            gap={{ base: 3, md: 8 }}>
            {companyLinks.map((link) => (
              <HStack
                key={link.label}
                as={RouterLink}
                to={link.href}
                spacing={2}
                _hover={{ color: 'gray.900' }}
                fontFamily="marketingPage"
                fontSize="md"
                fontWeight="medium">
                {companyIcons[link.label] && (
                  <ChakraIcon as={companyIcons[link.label]} w={4} h={4} />
                )}
                <Text>{link.label}</Text>
              </HStack>
            ))}
          </Flex>
        </Flex>

        <Divider my={6} borderColor="gray.200" />

        {/* Bottom row: Copyright + Legal links */}
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          gap={{ base: 4, md: 6 }}>
          <Text
            fontSize="sm"
            color="gray.500"
            fontFamily="marketingPage"
            whiteSpace="nowrap"
            flexShrink={0}>
            &copy; {new Date().getFullYear()} Yapamar
          </Text>
          <Flex flexWrap="wrap" gap={1} columnGap={6}>
            {legalLinks.map((link) => (
              <Text
                as={RouterLink}
                to={link.href}
                key={link.label}
                fontSize="sm"
                color="gray.500"
                fontFamily="marketingPage"
                _hover={{ color: 'gray.700' }}>
                {link.label}
              </Text>
            ))}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default MarketingPageFooter;
